const createDefaultState = () => ({
    availability: "none",
    isOn: false,
    windowVisible: false,
    lastText: null,
    languages: [],
    selectedLanguage: null,
});
export class SubtitleController {
    constructor(service) {
        this._unsubscribeService = null;
        this._currentStream = null;
        this._state = createDefaultState();
        this._subscribers = new Set();
        this._service = service;
        this._unsubscribeService = this._service.subscribe({
            onAvailabilityChanged: (availability) => this._setAvailability(availability),
            onLanguagesChanged: (languages, selected) => this._setLanguages(languages, selected),
            onText: (payload) => this._setText(payload),
        });
        this.refreshAvailability().catch(() => { });
    }
    subscribe(events) {
        const listener = events.onStateChanged;
        if (!listener)
            return () => { };
        const wrapper = (change, reason) => listener(change.next, reason);
        this._subscribers.add(wrapper);
        return () => this._subscribers.delete(wrapper);
    }
    get state() {
        return this._state;
    }
    async attachStream(stream) {
        this._currentStream = stream;
        await this.refreshAvailability();
    }
    async toggle() {
        const isCurrentlyOn = this._state.isOn;
        if (isCurrentlyOn) {
            await this._service.disable(this._currentStream);
        }
        else {
            await this._service.enable(this._currentStream);
        }
        this._toggleOnOff(!isCurrentlyOn);
        /*console.log("[Subtitles] toggle ->", !isCurrentlyOn, {
            availability: this._state.availability,
            stream: this._currentStream,
        });*/
    }
    async setLanguage(language) {
        await this._service.setLanguage(language, this._currentStream);
        this._setSelectedLanguage(language);
    }
    reset() {
        this._reset();
    }
    async refreshAvailability() {
        const availability = await this._service.getAvailability(this._currentStream);
        this._setAvailability(availability);
        if (availability === "available") {
            const { languages, selected } = await this._service.getLanguages(this._currentStream);
            this._setLanguages(languages, selected);
        }
        /*console.log("[Subtitles] refreshAvailability ->", availability, {
            stream: this._currentStream,
        });*/
    }
    setAvailabilityOverride(availability) {
        this._setAvailability(availability);
    }
    dispose() {
        if (this._unsubscribeService)
            this._unsubscribeService();
        this._unsubscribeService = null;
    }
    computeButtonState() {
        const s = this._state;
        if (s.availability === "none")
            return "hidden";
        if (s.availability === "inactive")
            return "inactive";
        return s.isOn ? "on" : "off";
    }
    _setState(next, reason) {
        const prev = this._state;
        this._state = next;
        const change = { prev, next };
        this._subscribers.forEach(cb => cb(change, reason));
    }
    _reset(reason = "reset") {
        this._setState(createDefaultState(), reason);
    }
    _setAvailability(availability) {
        const next = { ...this._state, availability };
        if (availability === "none") {
            next.lastText = null;
            next.languages = [];
        }
        this._setState(next, "availability");
    }
    _setLanguages(languages, selected) {
        this._setState({
            ...this._state,
            languages,
            selectedLanguage: selected,
        }, "language");
    }
    _setText(payload) {
        this._setState({
            ...this._state,
            lastText: payload,
            windowVisible: this._state.isOn || this._state.windowVisible,
        }, "text");
    }
    _toggleOnOff(value) {
        const next = { ...this._state, isOn: value };
        if (!value) {
            next.windowVisible = false;
        }
        else if (next.availability === "available") {
            next.windowVisible = true;
        }
        this._setState(next, "toggle");
    }
    _setSelectedLanguage(language) {
        this._setState({ ...this._state, selectedLanguage: language }, "language");
    }
}
